import { VOCAB_AUDIO_INSTRUCTIONS } from '../../vocab/vocabConstants';

import { LANGUAGES } from '../../common/localization';
import vocabTQVMPracticeInstructionStart from '../vocab_tqvm_practice_instruction_start.json';
import vocabTQVMPracticeReadyInstruction from '../vocab_tqvm_practice_ready_instruction.json';
import vocabTQVMQuestionInstructionReplay from '../vocab_tqvm_question_instruction_replay.json';
import vocabFITBPracticeInstructionStart from '../vocab_fitb_practice_instruction_start.json';
import vocabFITBInstructionReplay from '../vocab_fitb_practice_instruction_replay.json';
import vocabFITBPracticeReadyInstruction from '../vocab_fitb_practice_ready_instruction.json';
import vocabBDPracticeInstructionStart from '../vocab_bd_practice_instruction_start.json';
import vocabBDPracticeReadyInstruction from '../vocab_bd_practice_ready_instruction.json';
import vocabPracticeClickOk from '../click_ok.json';
import vocabTQVMPracticeInstructionStartSpanish from '../spanish/tqvm_practice_screen_active_state.json';
import vocabTQVMPracticeReadyInstructionSpanish from '../spanish/tqvm_practice_screen_ready_state.json';
import vocabTQVMQuestionInstructionReplaySpanish from '../spanish/selecciona_pulgar.json';
import vocabFITBPracticeInstructionStartSpanish from '../spanish/fitb_practice_screen_active_state.json';
import vocabFITBInstructionReplaySpanish from '../spanish/what_word_fills_in_the_blank.json';
import vocabFITBPracticeReadyInstructionSpanish from '../spanish/fitb_practice_screen_ready_state.json';
import vocabBDPracticeInstructionStartSpanish from '../spanish/bd_practice_screen_active_state.json';
import vocabBDPracticeReadyInstructionSpanish from '../spanish/bd_practice_screen_ready_state.json';
import vocabPracticeClickOkSpanish from '../spanish/clic_continuare.json';

export const VOCAB_CAPTIONS = {
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .vocabTQVMPracticeInstructionStart]: vocabTQVMPracticeInstructionStart,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .vocabTQVMPracticeReadyInstruction]: vocabTQVMPracticeReadyInstruction,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .vocabTQVMQuestionInstructionReplay]: vocabTQVMQuestionInstructionReplay,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .vocabFITBPracticeInstructionStart]: vocabFITBPracticeInstructionStart,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .vocabFITBInstructionReplay]: vocabFITBInstructionReplay,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .vocabFITBPracticeReadyInstruction]: vocabFITBPracticeReadyInstruction,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .vocabBDPracticeInstructionStart]: vocabBDPracticeInstructionStart,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH]
        .vocabBDPracticeReadyInstruction]: vocabBDPracticeReadyInstruction,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.ENGLISH].clickOk]: vocabPracticeClickOk,
};

export const VOCAB_SPA_CAPTIONS = {
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .vocabTQVMPracticeInstructionStart]: vocabTQVMPracticeInstructionStartSpanish,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .vocabTQVMPracticeReadyInstruction]: vocabTQVMPracticeReadyInstructionSpanish,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .vocabTQVMQuestionInstructionReplay]: vocabTQVMQuestionInstructionReplaySpanish,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .vocabFITBPracticeInstructionStart]: vocabFITBPracticeInstructionStartSpanish,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .vocabFITBInstructionReplay]: vocabFITBInstructionReplaySpanish,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .vocabFITBPracticeReadyInstruction]: vocabFITBPracticeReadyInstructionSpanish,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .vocabBDPracticeInstructionStart]: vocabBDPracticeInstructionStartSpanish,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH]
        .vocabBDPracticeReadyInstruction]: vocabBDPracticeReadyInstructionSpanish,
    [VOCAB_AUDIO_INSTRUCTIONS[LANGUAGES.SPANISH].clickOk]: vocabPracticeClickOkSpanish,
};
